import { delay } from '@vzmi/component_ec_nodejs_util/dist/lib/renderUtil'
import useOnInit from './useOnInit'
import { handleBeforeunload } from '../../Proposal/Common/BeforeUnload'

const useBeforeunload = async (isOverviewPage, callback) => {
  useOnInit(() => {
    if (!global.window) {
      return
    }

    global.window.addEventListener('beforeunload', onBeforeUnload)
    return () => unbindBeforeunload()
  })

  const unbindBeforeunload = () => {
    global.window && global.window.removeEventListener('beforeunload', onBeforeUnload)
  }

  const onBeforeUnload = event => {
    callback && callback(event)
    handleBeforeunload(event)
  }

  if (isOverviewPage) {
    await delay(1)
    unbindBeforeunload()
  }

  return { unbindBeforeunload }
}

export default useBeforeunload
